export class Zone {
    public zoneId: number;
    public name: string;
    public description: string;
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/share/zones/zone.model.ts